module.exports = __webpack_public_path__ + "assets/img/martin_sheen-fe677906.jpg";